module.exports = __webpack_public_path__ + "static/media/accordionAngle.e7362ee2.svg";